module.exports = __webpack_public_path__ + "components/outside-promo-page/static/weather-forecast__icon-5083bb12f0cf1228375a15f83e7e3da4.svg";